import {Schema, useUrlFilters} from '../useUrlFilters';
import type {SelectedInputGroup} from './types/filters.type';

export interface LabListingFilters {
  search: string;
  order_by: string;
  input_guid: SelectedInputGroup[];
}

const defaultSchema: Schema<LabListingFilters> = {
  search: {type: 'string', default: ''},
  order_by: {type: 'string', default: 'distance'},
  input_guid: {type: 'json', default: []},
};

export function useLabListingFilters() {
  const {values, setFilter, setFilters, resetFilter, reset} =
    useUrlFilters<LabListingFilters>(defaultSchema);

  return {
    labListingFilters: values,
    setFilterLabListing: setFilter,
    setFiltersLabListing: setFilters,
    resetFilterLabListing: resetFilter,
    resetLabListing: reset,
  };
}
